import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import noMessageIcon from '../../assets/Images/no-tray.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import TrayStatusEnum from '../../constants/enums/tray-status-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  TrayDefaultSortColumnOrder,
  TrayFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import {
  ITrayCSV,
  ITrayListFilter,
  ITrayListPayload,
} from '../../models/ITrayFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';

import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  ExportHolidayIcon,
  ExportTrayIcon,
  HistoryIcon,
  ImportHolidayIcon,
  PlusIcon,
  RefreshIcon,
  TrayMgmtCompletedViewIcon,
  TrayMgmtDeletedViewIcon,
  TrayMgmtGefaultViewIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditTrayManagement from './components/add-edit-tray-management';
import FilterComponent from './components/filter';
import ImportTrayDetails from './components/import-tray-details';
import AddEditTrayManagementPopupHOC from './hoc/add-edit-tray-management-popup-hoc';
import ImportTrayDetailsPopupHOC from './hoc/import-tray-details-popup-hoc';
import TrayDetails from './tray-details';
import './tray-management.css';
import TrayPrintFilesHistoryDetails from './tray-print-files-history-details';

const TrayManagement = (props: any) => {
  const { preferencesStore, trayManagementStore } = useStore();
  const {
    GetTrayListService,
    getTrayListServiceState,
    allTrays,
    trayList,
    deleteTrayState,
    trayState,
    DeleteTrayService,
    resetDeleteTray,
    resetTrayDetail,
    addUpdateTrayState,
    resetAddUpdateTrayState,
    fileUploadState,
    resetFileUploadState,
    duplicateData,
    getTrayFilesHistoryState,
    getDownloadrayFilesHistoryState,
    base64String,
    resetExportFileState,
    GetTrayReportService,
    getTrayReportState,
    resetGetTrayReportState,
    ExportTrayCSVService,
    exportTrayCSVState,
    resetExportTrayCSVState,
  } = trayManagementStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allTrayListData = allTrays;
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TrayDefaultSortColumnOrder
  );
  const [noBackdrop, setNoBackdrop] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [selectedRowTrayId, setSelectedRowTrayId] = useState('');
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [showCompletedTrays, setShowCompletedTrays] = useState(false);
  const [showDeletedTrays, setShowDeletedTrays] = useState(false);

  type TagViewMode = 'normal' | 'deleted' | 'completed';
  const [tagViewMode, setTagViewMode] = useState<TagViewMode>('normal');

  const [filterObj, setFilterObj] = useState<ITrayListFilter>(
    TrayFilterInitialState
  );
  const [openHistoryPanel, setOpenHistoryPanel] = useState(false);

  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getTrayListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    let currentFilter: any = {};
    if (typeof filterQuery === 'string' && filterQuery) {
      try {
        const decoded = decodeURIComponent(filterQuery);
        decoded.split('#').forEach((part) => {
          const [key, val] = part.split('=');
          if (key) {
            currentFilter[key] = val != null ? decodeURIComponent(val) : '';
          }
        });
      } catch {
        currentFilter = { ...filterObj };
      }
    } else {
      currentFilter = {
        ...filterObj,
        IsComplete: showCompletedTrays,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      };
    }

    const payload: ITrayListPayload = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      Paging: {
        CurrentPage: isFilter ? 1 : pageInfo.currentPage,
        PageSize: pageLimitInfo.pageLimit,
        TotalPages: 0,
        TotalRecords: 0,
      },
      Filter: {
        TrayId: currentFilter?.TrayId || '',
        OrderId:
          currentFilter?.OrderId != null ? String(currentFilter.OrderId) : '',
        ProductId: currentFilter?.ProductId || '',
        CustomerId: currentFilter?.CustomerId || '',
        EUOrderNo: currentFilter?.EUOrderNo || '',
        CustomerDueDate: currentFilter?.CustomerDueDate || '',
        IsDeleted:
          currentFilter?.IsDeleted !== undefined
            ? currentFilter.IsDeleted === true ||
              currentFilter.IsDeleted === 'true'
            : tagViewMode === 'deleted',
        Column: currentFilter?.Column || columSortOrder.dataField || '',
        Order: currentFilter?.Order || columSortOrder.order || '',
        IsComplete:
          currentFilter?.IsComplete !== undefined
            ? currentFilter.IsComplete === true ||
              currentFilter.IsComplete === 'true'
            : tagViewMode === 'completed' || showCompletedTrays,
      },
    };

    GetTrayListService(payload);
  };

  const openImportFileHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    props.addToggleHandler();
    resetTrayDetail();
  };

  useEffect(() => {
    getTrayListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: trayList?.PagingDetails?.CurrentPage,
      totalPages: trayList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [trayList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getTrayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getTrayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(` ${formatMessage(duplicateData)}`);
      resetFileUploadState();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (addUpdateTrayState.success) {
      resetAddUpdateTrayState();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateTrayState.success]);

  useEffect(() => {
    if (deleteTrayState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteTray();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTrayState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    if (row.CurrentState === TrayStatusEnum.Complete) {
      className = 'active-tray-row';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    setOpenHistoryPanel(false);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const toggleHistoryDetails = () => {
    if (openHistoryPanel) {
      setOpenPanel(false);
    }

    if (!openPanel) {
      setOpenPanel((prev) => !prev);
    }

    setOpenHistoryPanel((prev) => !prev);
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    setOpenHistoryPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({
      ...filterObj,
      IsComplete: showCompletedTrays,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    getTrayListServiceHandler(filter);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteTrayService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedRowTrayId(row.TrayId);
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    props.deletePopupToggleHandler();
  };

  const openAddTrayHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    setSelectedId(row.Id);
    props.addTrayToggleHandler();
  };

  const exportTrayReportClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    GetTrayReportService(
      Number(getTenantIdFromLocalStorage()),
      row.Id,
      row.TrayId
    );
    setSelectedRowTrayId(row.TrayId);
    // setSelectedId(row.Id);
    // props.deletePopupToggleHandler();
  };

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TrayHistory-${Date.now()}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // closePanelHandler();
    // resetFactoryScheduleDetail();
  };

  const handleCSVExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TrayReportFile-${Date.now()}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // closePanelHandler();
    // resetFactoryScheduleDetail();
  };

  const handleExportTray = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TrayReport_${selectedRowTrayId}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (
      getDownloadrayFilesHistoryState.success &&
      base64String.fileString.length > 0
    ) {
      handleExport(base64String.fileString);
      resetExportFileState();
    }
  }, [getDownloadrayFilesHistoryState.success]);

  useEffect(() => {
    if (getTrayReportState.success && base64String.fileString.length > 0) {
      handleExportTray(base64String.fileString);
      resetGetTrayReportState();
    }
  }, [getTrayReportState.success]);

  useEffect(() => {
    if(exportTrayCSVState.success && base64String.fileString.length > 0){
      handleCSVExport(base64String.fileString);
      resetExportTrayCSVState();
    }
  }, [exportTrayCSVState.success]);

  useEffect(() => {
    if(exportTrayCSVState.error){
      toast.error(formatMessage(exportTrayCSVState.error));
    }
  }, [exportTrayCSVState.error]);

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'EUOrderNo':
        return 'eu_order_no';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'PlanedDueDate':
        return 'planed_due_date';
      case 'ProductId':
        return 'product_id';
      case 'CustomerId':
        return 'customer_id';
      default:
        return 'tray_id';
    }
  }

  const createQueryString = (filter: ITrayListFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITrayListFilter) => {
    const filter = createQueryString({
      ...object,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
      IsComplete: showCompletedTrays,
    });
    getTrayListServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      IsComplete: showCompletedTrays,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    // resetGetFactoryDetail();
  };

  const filterParams = (obj: ITrayListFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
      IsComplete: isfilterCleard ? false : showCompletedTrays,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      setShowCompletedTrays(false);
      getTrayListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (
      newState.sortField !== columSortOrder.dataField ||
      newState.sortOrder !== columSortOrder.order
    ) {
      setColumnSortOrder({
        ...columSortOrder,
        dataField: newState.sortField,
        order: newState.sortOrder,
      });
      const filter = createQueryString({
        ...filterObj,
        Column: newState.sortField,
        Order: newState.sortOrder,
      });
      getTrayListServiceHandler(filter, true);
    }
  };

  const handleTagViewChange = (mode: TagViewMode) => {
    // setSelectedIds([]);
    setTagViewMode(mode);

    const queryString = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      IsDeleted: mode === 'deleted',
      IsComplete: mode === 'completed',
    });

    setFilterObj((prev) => ({
      ...prev,
      IsDeleted: mode === 'deleted',
      IsComplete: mode === 'completed',
    }));

    getTrayListServiceHandler(queryString, true);
  };

  const exportFileHandler = () => {
    const tenantId = Number(getTenantIdFromLocalStorage());
    const payload: ITrayCSV = {
      TenantId: tenantId,
      Filter: filterObj
    };

    ExportTrayCSVService(payload);
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'trayExport',
        handler: exportTrayReportClickHandler,
        // handler: {},
        icon: <ExportTrayIcon />,
        isDisable: false,
        title: 'export',
        varient: 'success',
        action: 'export',
      },
      {
        dataField: 'isEdit',
        handler: openAddTrayHandler,
        icon: <EditIcon />,
        isDisable:
          !isOperationPermittedRoleBase(ModuleType.TrayManagement, 'Edit') ||
          tagViewMode === 'deleted',
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable:
          !isOperationPermittedRoleBase(ModuleType.TrayManagement, 'Delete') ||
          tagViewMode === 'deleted',
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.TrayManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },

    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerId',
      text: formatMessage('customer_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      classes: 'show-Elipses',
      sort: true,
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'EndUserName',
      text: formatMessage('end_user_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('end_user_order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    // {
    //   dataField: 'TenantId',
    //   text: formatMessage('tenant_id'),
    //   classes: 'show-Elipses',
    // },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'SubContractor',
      text: formatMessage('sub_contractor'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki1',
      text: formatMessage('katashiki_1'),
      // classes: 'show-Elipses',
      formatter: (cell) => {
        return cell && cell.length > 33 ? cell.substring(0, 33) + '...' : cell;
      },
      title: (cell: string) => {
        return cell.length > 33 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki2',
      text: formatMessage('katashiki_2'),
      // classes: 'show-Elipses',
      formatter: (cell) => {
        return cell && cell.length > 33 ? cell.substring(0, 33) + '...' : cell;
      },
      title: (cell: string) => {
        return cell.length > 33 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProcessName',
      text: formatMessage('process_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
      hidden: true,
    },
    {
      dataField: 'Quantity',
      text: formatMessage('quantity'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'InvoiceNumber',
      text: formatMessage('invoice_number'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'QuantityUnitName',
      text: formatMessage('quantity_unit_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'MissingParts',
      text: formatMessage('missing_parts'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'TagId',
      text: formatMessage('tag_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: !showCompletedTrays,
    },
    {
      dataField: 'ProductComment1',
      text: formatMessage('product_comment_1'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment2',
      text: formatMessage('product_comment_2'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment3',
      text: formatMessage('product_comment_3'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment4',
      text: formatMessage('product_comment_4'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment5',
      text: formatMessage('product_comment_5'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment6',
      text: formatMessage('product_comment_6'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },

    {
      dataField: 'PlanedDueDate',
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      hidden: true,
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];
  return (
    <>
      {props.showImportPopup && (
        <ImportTrayDetails
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showAddTrayManagementPopup && (
        <AddEditTrayManagement
          id={selectedId}
          modalClosed={props.addTrayToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_tray"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tray_confirm"
          isLoading={deleteTrayState.inProgress}
          id={selectedRowTrayId}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="tray_management"
          />
          <div className="col-auto">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={
                    false
                    // getTenantIdFromLocalStorage() === "-1" &&
                    // selectedTenantId === -1
                  }
                  // isFilterCleared={false}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TrayManagement,
                'Add'
              ) && (
                <li title={formatMessage('import')}>
                  <a
                    data-toggle="modal"
                    className={`btn btn-light`}
                    onClick={(event: any) => openImportFileHandler(event)}
                  >
                    <ImportHolidayIcon />
                  </a>
                </li>
              )}
              <li title={formatMessage('factory_schedule_export')}>
                <a
                  data-toggle="modal"
                  className={`btn btn-light`}
                  onClick={() => exportFileHandler()}
                >
                  <ExportHolidayIcon />
                </a>
              </li>
              <ul className="tableAccordian-switch d-flex">
                <li
                  className={tagViewMode === 'normal' ? 'active' : ''}
                  onClick={(e: any) => handleTagViewChange('normal')}
                >
                  <TrayMgmtGefaultViewIcon />
                  <span className="icon-text">
                    {formatMessage('default_view')}
                  </span>{' '}
                </li>
                <li
                  className={tagViewMode === 'completed' ? 'active' : ''}
                  onClick={(e: any) => handleTagViewChange('completed')}
                >
                  <TrayMgmtCompletedViewIcon />{' '}
                  <span className="icon-text">
                    {formatMessage('show_completed_trays')}
                  </span>
                </li>
                {/* <li
                  className={tagViewMode === 'deleted' ? 'active' : ''}
                  onClick={(e: any) => handleTagViewChange('deleted')}
                >
                  <TrayMgmtDeletedViewIcon />{' '}
                  <span className="icon-text">
                    {formatMessage('show_deleted_trays')}
                  </span>
                </li> */}
              </ul>

              <li title={formatMessage('history')}>
                <a
                  className="btn btn-primary btn-blue d-flex align-items-center"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={toggleHistoryDetails}
                >
                  <span className="me-1">
                    {' '}
                    <HistoryIcon />
                  </span>
                  <FormattedMessage id="history" />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TrayManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_tray')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddTrayHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <PlusIcon />
                    </span>
                    <FormattedMessage id="add_tray" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getTrayListServiceState.inProgress ||
            trayState.inProgress ||
            deleteTrayState.inProgress ||
            addUpdateTrayState.inProgress ||
            getTrayFilesHistoryState.inProgress ||
            getDownloadrayFilesHistoryState.inProgress) && (
            <FormLoader
              loading={
                getTrayListServiceState.inProgress ||
                trayState.inProgress ||
                deleteTrayState.inProgress ||
                addUpdateTrayState.inProgress ||
                getTrayFilesHistoryState.inProgress ||
                getDownloadrayFilesHistoryState.inProgress
              }
            />
          )}
          {allTrayListData && allTrayListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive tray-management-table"
                    data-testid="table"
                  >
                    {allTrayListData && (
                      <Grid
                        data={allTrayListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ sort: true }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allTrayListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={trayList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    {showCompletedTrays ? (
                      <FormattedMessage id="no_tray_completed" />
                    ) : (
                      <FormattedMessage id="no_tray" />
                    )}
                  </h3>
                  <h4 className="mb-3">
                    {showCompletedTrays
                      ? formatMessage('no_tray_completed_message')
                      : formatMessage('no_tray_message')}
                  </h4>

                  {isOperationPermittedRoleBase(
                    ModuleType.TrayManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddTrayHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_tray" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <div className={`${openHistoryPanel ? 'history-pannel' : ''}`}> */}
      <div className="history-pannel">
        <SlidingPanel
          type={'right'}
          isOpen={openPanel}
          noBackdrop={false}
          size={openHistoryPanel ? 100 : 100}
          // backdropClicked={() => setOpenPanel(false)}
        >
          <div className="bg_slide panel ">
            <div className="row bb p-2 pl-4 g-0 align-items-center ">
              <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                  {!openHistoryPanel ? (
                    selectedRow.TrayId
                  ) : (
                    <FormattedMessage id="history" />
                  )}
                </h2>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
                <span title={formatMessage('close')}>
                  <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
                </span>
              </div>
            </div>
            <div className="group_detailsWrapper tray-detail pb-3">
              {!openHistoryPanel ? (
                <TrayDetails selectedRowId={selectedRow.Id} />
              ) : (
                <div className="tray-detail">
                  <TrayPrintFilesHistoryDetails />
                </div>
              )}
            </div>
          </div>
        </SlidingPanel>
      </div>
    </>
  );
};

export default ImportTrayDetailsPopupHOC(
  FilterPopupHOC(
    AddEditTrayManagementPopupHOC(DeletePopupHOC(observer(TrayManagement)))
  )
);
